import { Routes, Route } from "react-router-dom";
import { Header } from "./components/header";
import { TabNav } from "./components/tab-nav";
import { HexRain } from "./components/hex-rain";
import { FreqWidget } from "./components/freq-widget";
import { BackgroundPrefetcher } from "./components/background-prefetcher";
import EVPacksPage from "./pages/ev-packs";
import CollectionsPage from "./pages/collections";
import SinglesPage from "./pages/singles";
import TopPullsPage from "./pages/top-pulls";
import WatchlistPage from "./pages/watchlist";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col relative">
      <HexRain />
      <Header />
      <TabNav />
      {/* Warms sibling tabs' data after the current page finishes loading so
          tab switches feel instant without slowing down the first paint. */}
      <BackgroundPrefetcher />

      {/* Bottom padding keeps the last row clear of the fixed status bar +
          footer (~50px mobile, ~56px desktop). */}
      <main className="flex-1 relative z-10 pb-[52px] md:pb-[60px]">
        <Routes>
          <Route path="/" element={<TopPullsPage />} />
          <Route path="/ev-packs" element={<EVPacksPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/singles" element={<SinglesPage />} />
          {/* Back-compat: keep /top-pulls pointing at the same page so any
              existing bookmarks or links continue to work. */}
          <Route path="/top-pulls" element={<TopPullsPage />} />
          <Route path="/watchlist" element={<WatchlistPage />} />
        </Routes>
      </main>
      {/* Fixed status bar — FREQ meter compact on mobile, wider on desktop. */}
      <div className="fixed bottom-[24px] md:bottom-[28px] left-0 right-0 z-40 border-t border-border bg-panel/70 backdrop-blur-sm px-2 md:px-3 flex items-center gap-4 h-[24px] md:h-[26px] overflow-hidden pointer-events-none">
        <div className="ml-auto flex-shrink-0 opacity-85 md:hidden">
          <FreqWidget bars={10} rows={3} cell={4} label="FRQ" />
        </div>
        <div className="ml-auto flex-shrink-0 opacity-85 hidden md:block">
          <FreqWidget bars={20} rows={3} cell={5} label="FREQ" />
        </div>
      </div>
      <footer className="fixed bottom-0 left-0 right-0 z-40 h-[24px] md:h-[28px] border-t border-border bg-panel/80 backdrop-blur-sm px-3 md:px-4 text-[9px] md:text-[10px] font-mono text-muted flex items-center gap-2 md:gap-4 overflow-hidden whitespace-nowrap">
        <span className="shrink-0">
          <span className="text-accent2">›</span> slab.scanner
          <span className="animate-blink text-accent ml-1">_</span>
        </span>
        <span className="hidden sm:inline shrink-0">api: slab.cash/v1</span>
        <span className="hidden sm:inline shrink-0">chains: base · apechain</span>
        <span className="ml-auto text-accent/60 shrink-0">[ active ]</span>
      </footer>
    </div>
  );
}
